export const ChangeTypeEnum = {
  /**待处理 0 */
  Pending: "0",
  /**转换中 1 */
  TransformationIng: "1",
  /**转换成功 2 */
  ConversionSuccess: "2",
  /**转换失败 3 */
  ConversionFailure: "3",
  /**撤消中 4 */
  RevokeIng: "4",
  /**撤销成功 5 */
  RevokeSuccess: "5",
  /**撤销失败 6 */
  RevokeFailure: "6",
};

export const ChangeTypeList = [
  { label: "待处理", value: ChangeTypeEnum.Pending },
  { label: "转换中", value: ChangeTypeEnum.TransformationIng },
  { label: "转换成功", value: ChangeTypeEnum.ConversionSuccess },
  { label: "转换失败", value: ChangeTypeEnum.ConversionFailure },
  { label: "撤消中", value: ChangeTypeEnum.RevokeIng },
  { label: "撤销成功", value: ChangeTypeEnum.RevokeSuccess },
  { label: "撤销失败", value: ChangeTypeEnum.RevokeFailure },
];

export const ChangeTypeMap = {
  [ChangeTypeEnum.Pending]: {
    text: "待处理",
    style: "color: #EDC77C",
  },
  [ChangeTypeEnum.TransformationIng]: {
    text: "转换中",
    style: "color: #EDC77C",
  },
  [ChangeTypeEnum.ConversionSuccess]: {
    text: "转换成功",
    style: "color: #4fa1a4",
  },
  [ChangeTypeEnum.ConversionFailure]: {
    text: "转换失败",
    style: "color: #F67058",
  },
  [ChangeTypeEnum.RevokeIng]: {
    text: "撤消中",
    style: "color: #EDC77C",
  },
  [ChangeTypeEnum.RevokeSuccess]: {
    text: "撤销成功",
    style: "color: #4fa1a4",
  },
  [ChangeTypeEnum.RevokeFailure]: {
    text: "撤销失败",
    style: "color: #F67058",
  },
};

/** v26.3.3 数据标注：数据标注任务类型的字典值（测试库"任务类型"现有 1正式/2测试/3更新任务转换模版，"数据标注"=4 已随 dict-init 脚本同步） */
export const LABEL_TASK_TYPE = "4";
